import _define_property from "@swc/helpers/src/_define_property.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _to_consumable_array from "@swc/helpers/src/_to_consumable_array.mjs";
import { createSafeContext } from "@components/mantine";
import { noAccess } from "./PrivilegesTableConstants.js";
var ref = _sliced_to_array(createSafeContext("PrivilegesTable component was not found in the tree"), 2);
export var PrivilegesTableContextProvider = ref[0], usePrivilegesTableContext = ref[1];
export var usePrivilegeRow = function(id) {
    var ref;
    var _ref = usePrivilegesTableContext(), selectedPrivilegesByRowId = _ref.selectedPrivilegesByRowId, onChange = _ref.onChange, customPrivileges = _ref.customPrivileges, setCustomPrivileges = _ref.setCustomPrivileges, others = _object_without_properties(_ref, [
        "selectedPrivilegesByRowId",
        "onChange",
        "customPrivileges",
        "setCustomPrivileges"
    ]);
    var scopedOnChange = function(privileges) {
        onChange === null || onChange === void 0 ? void 0 : onChange(Object.values(_object_spread_props(_object_spread({}, selectedPrivilegesByRowId), _define_property({}, id, privileges))).flat());
    };
    return _object_spread({
        selectedPrivileges: selectedPrivilegesByRowId[id] || noAccess,
        customSelected: customPrivileges.includes(id) || ((ref = selectedPrivilegesByRowId[id]) === null || ref === void 0 ? void 0 : ref.some(function(param) {
            var targetId = param.targetId;
            return !!targetId && targetId !== "*";
        })),
        selectCustom: function(selected) {
            setCustomPrivileges(function(current) {
                return selected ? _to_consumable_array(current).concat([
                    id
                ]) : current.filter(function(item) {
                    return item !== id;
                });
            });
        },
        onChange: scopedOnChange,
        setCustomPrivileges: setCustomPrivileges
    }, others);
};

//# sourceMappingURL=PrivilegeTableContext.js.map